<template>
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="fs-6 mb-0">
        Trend History
        <a href="https://www.youtube.com/watch?v=6G17MbjeX8c" target="_blank" title="Watch explainer video"><span class="fab fa-youtube" data-fa-transform="right-0 down-1"></span></a>
      </h5>
      <p class="mb-0">
        <span v-if="detector == 'gc'">This chart shows how many assets are in an Uptrend (Green) or Downtrend (Red).</span>
        <span v-if="detector == 'b2s'">This chart shows how many assets are in an Uptrend (Green), Downtrend (Red) or Undecided (Grey).</span>
      </p>
    </div>
    <div class="card-body">
      <Line ref="lineChart" :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template> 

<script>
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, Filler } from 'chart.js'
import { Line } from 'vue-chartjs'
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, Filler)

export default {
  name: 'TrendRadarChart',
  components: { Line },
  props: {
    data: { type: Array, required: true },
    detector: { type: String, default: 'gc' }
  },
  computed: {
    theme () { return this.$store.getters.getTheme },
    labelColor () { return this.theme === 'dark' ? 'rgb(157, 169, 187)' : 'rgb(94, 110, 130)' },
    gridColor () { return this.theme === 'dark' ? 'rgba(157, 169, 187, 0.15)' : 'rgba(94, 110, 130, 0.1)' },
    chartData () {
      const sorted = [...this.data].sort((a, b) => a.runDate.localeCompare(b.runDate))
      const datasets = [
        {
          label: 'Uptrend', data: sorted.map(d => Number(d.green)),
          borderColor: '#28a745', backgroundColor: 'rgba(40, 167, 69, 0.1)',
          fill: true, tension: 0.3, pointRadius: 2, pointHoverRadius: 5, borderWidth: 2
        }
      ]
      if (this.detector === 'b2s') {
        datasets.push({
          label: 'Undecided', data: sorted.map(d => Number(d.grey)),
          borderColor: '#6c757d', backgroundColor: 'rgba(108, 117, 125, 0.1)',
          fill: true, tension: 0.3, pointRadius: 2, pointHoverRadius: 5, borderWidth: 2
        })
      }
      datasets.push({
        label: 'Downtred', data: sorted.map(d => Number(d.red)),
        borderColor: '#dc3545', backgroundColor: 'rgba(220, 53, 69, 0.1)',
        fill: true, tension: 0.3, pointRadius: 2, pointHoverRadius: 5, borderWidth: 2
      })
      return {
        labels: sorted.map(d => { const p = d.runDate.split('-'); return p[1] + '/' + p[2] }),
        datasets
      }
    },
    chartOptions () {
      const lc = this.labelColor, gc = this.gridColor
      return {
        responsive: true, maintainAspectRatio: true, aspectRatio: window.innerWidth < 768 ? 1.2 : 3, animation: false,
        plugins: {
          legend: { position: 'top', labels: { color: lc, usePointStyle: true, pointStyle: 'circle', padding: 15 } },
          tooltip: { callbacks: { label: function (ctx) {
            const v = Number(ctx.dataset.data[ctx.dataIndex]) || 0
            const t = ctx.chart.data.datasets.reduce((s, ds) => s + (Number(ds.data[ctx.dataIndex]) || 0), 0)
            return ctx.dataset.label + ': ' + v + ' (' + (t > 0 ? Math.round(v / t * 100) : 0) + '%)'
          }}}
        },
        scales: {
          x: { ticks: { color: lc, maxRotation: 0, autoSkipPadding: 10 }, grid: { display: false } },
          y: { ticks: { color: lc }, grid: { color: gc } }
        }
      }
    }
  },
  methods: {
    handleResize () {
      const chart = this.$refs.lineChart?.chart
      if (chart) {
        chart.options.aspectRatio = window.innerWidth < 768 ? 1.2 : 3
        chart.resize()
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
